import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY, SESSION_STORAGE_SSO_ACCESS_TOKEN_KEY, deleteConsumerApplicationId } from "../../../../sessionStorage";
import { parseHealthData, parseHealthHiddenData } from "./ParseHealth";
import TobaccoUsage from "./TobaccoUsage";
import { savedQuoteEmailDrip } from "./SavedQuoteEmailDrip";

export const postApp = (basicInfo, quoter, healthData, formState, termLength, journeyType='') => {

  const basicInfoTobacco = TobaccoUsage(basicInfo.tobacco);
  const tobaccoStatus = (basicInfoTobacco === "yes" || basicInfoTobacco === "no") ? basicInfoTobacco : (basicInfoTobacco === "true" ? "yes" : "no");

  const calculateTotalHeight = (height) => {
    const radix = 10;
    const heightArray = height.split(' ');
    const heightFeet = parseInt(heightArray[0], radix);
    let heightInches;
    for (let i = 1; i < heightArray.length; i++) {
      if (heightArray[i] !== '' && heightArray[i] !== 'ft') {
        heightInches = parseInt(heightArray[i], radix);
        break;
      }
    }
    return `${heightFeet} ${heightInches}`;
  }

  const body = {
    'consumerAccountId': getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).account.accountId,
    'oneClickAccountId': getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).account.oneClickAccountId,
    'dob': basicInfo.birthdate,
    'firstname': formState.firstName || basicInfo.firstName,
    'lastname': formState.lastName || basicInfo.lastName,
    'gender': basicInfo.gender,
    'usCitizen': basicInfo.usResident,
    'weight': basicInfo.weight ? basicInfo.weight.split(" ")[0] : '',
    'height': basicInfo.height ? calculateTotalHeight(basicInfo.height) : '',
    'healthclass': quoter.healthClass,
    'state': basicInfo.state,
    'zipCode': basicInfo.zipCode || 0,
    'phone': formState.phone,
    'face': quoter.coverageAmount,
    'tobacco': TobaccoUsage(tobaccoStatus) === 'yes',
    'email': basicInfo.email || formState.email,
    'term': parseInt(termLength, 10),
    'carrier': quoter.carrierName,
    'product': quoter.product,
    'quotedpremium': quoter.premium,
    'quotedpremiummode': 'M',
    'specialNote': quoter.specialNote || '',
    'timeZone': formState.timeZone,
    'specificappointmentutc': formState.specificAppt === 'schedule' ? `${formState.specificApptDate} ${formState.specificApptTime}` : null,
    'leadCustomData': healthData ? parseHealthData(healthData) : {},
    'leadCustomHiddenData': healthData ? parseHealthHiddenData(healthData) : {},
    'journeyType': journeyType,
    'configurableQuestions': formState.configurableQuestions,
  };

  return new Promise((resolve, reject) => {
    const accessToken = getSessionStorageItem(SESSION_STORAGE_SSO_ACCESS_TOKEN_KEY);
    const covrServicesUrl = window.__ENV__.REACT_APP_COVR_SERVICES_URL

    fetch(`${covrServicesUrl}/api/Case/PostApp`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'SessionId': getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).sessionId,
        'X-Consumer-Application-ID': getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).consumerApplicationId,
        'Authorization': accessToken ? 'Bearer ' + accessToken : null,
      },
      body: JSON.stringify(body),
    })
    .then(deleteConsumerApplicationId)
    .then((data) => {
      resolve(data);
      savedQuoteEmailDrip(body.email);
    }).catch((error) => {
      reject(error);
    });
  });
};
